(() => {
  const instances = new WeakMap();
  function init() {
    const section = document.getElementById('foundation-teaser');
    if (!section || instances.has(section)) return;
    const wrapper = section.closest('.shopify-section');
    const hero = wrapper && wrapper.previousElementSibling;
    if (hero) hero.classList.add('mthr-reveal-hero');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let frame = 0;
    let revealStart = 0;
    let heroHideAt = Infinity;
    let revealDistance = 1;
    let inset = 16;
    let lastInset = '';
    function paintReveal() {
      frame = 0;
      // The sticky layer is only needed until the buy box fully covers it.
      if (hero) hero.classList.toggle('mthr-reveal-hero--covered', window.scrollY >= heroHideAt);
      const progress = motion.matches ? 1 : Math.max(0, Math.min(1, (window.scrollY - revealStart) / revealDistance));
      const eased = progress * progress * (3 - 2 * progress);
      const value = `${(inset * (1 - eased)).toFixed(2)}px`;
      if (value !== lastInset) {
        section.style.setProperty('--reveal-inset', value);
        lastInset = value;
      }
    }
    function update() {
      frame = 0;
      const mobile = window.innerWidth < 750;
      inset = mobile ? 16 : 48;
      if (hero) {
        const heroStart = hero.parentElement.getBoundingClientRect().top + window.scrollY;
        wrapper.style.marginTop = `-${Math.max(0, heroStart + (mobile ? 32 : 48))}px`;
      }
      const panelTop = section.getBoundingClientRect().top + window.scrollY;
      heroHideAt = panelTop + (mobile ? 24 : 40);
      revealStart = panelTop - window.innerHeight * .9;
      revealDistance = window.innerHeight * .5;
      paintReveal();
    }
    function schedule() {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    }
    // Scroll frames only paint the silhouette: no layout reads or width writes.
    function onScroll() { if (!frame) frame = requestAnimationFrame(paintReveal); }
    section.classList.add('mthr-buybox-reveal');
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', schedule);
    motion.addEventListener('change', schedule);
    const observer = new ResizeObserver(schedule);
    observer.observe(document.body);
    instances.set(section, () => { window.removeEventListener('scroll',onScroll); window.removeEventListener('resize',schedule); motion.removeEventListener('change',schedule); observer.disconnect(); wrapper.style.marginTop=''; if(hero){hero.style.transform='';hero.classList.remove('mthr-reveal-hero', 'mthr-reveal-hero--covered');} cancelAnimationFrame(frame); instances.delete(section); });
    update();
  }
  document.addEventListener('shopify:section:unload', e => { const section=e.target.querySelector('#foundation-teaser'); if(section) instances.get(section)?.(); });
  document.addEventListener('shopify:section:load',init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
